module.exports = __webpack_public_path__ + "static/media/imgMarketing01.0bfabe42.png";